<h3 class="test-style">{{vizName}}</h3>
<svg width="100%" height="500px" id="{{containerId}}"></svg>
